export const GAME_TITLE = 'BTS Heardle'
export const GAME_LINK = 'https://bts-heardle.app/'

export const WIN_MESSAGES = ['IKDR!', 'Exactly.', 'ARMY card never declines', 'Blood does run purple!', "SAURR TRUEE", "Purple blood runs in your veins.", "Congratulations! Your ARMY card is not revoked today.", "Assignment is understood"]
export const LOST_MESSAGES = ['Life goes on...', 'Purple card: confiscated', 'ARMY card declined.', 'An attempt was made', 'New song to be obssesed with?']
export const GAME_COPIED_MESSAGE = 'Game copied to clipboard'
export const ABOUT_GAME_MESSAGE = 'About this game'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Not enough letters'
export const WORD_NOT_FOUND_MESSAGE = 'Word not found'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `The word was ${solution}`
export const ENTER_TEXT = 'ENTER'
export const DELETE_TEXT = 'Delete'
export const STATISTICS_TITLE = 'BTS Heardle Statistics'
export const GUESS_DISTRIBUTION_TEXT = 'Guess Distribution'
export const NEW_WORD_TEXT = 'New song in'
export const SHARE_TEXT = 'Share'
export const TOTAL_TRIES_TEXT = 'Total tries'
export const SUCCESS_RATE_TEXT = 'Success rate'
export const CURRENT_STREAK_TEXT = 'Current streak'
export const BEST_STREAK_TEXT = 'Best streak'
